/* 数据验证函数集合对象 */
import { getUtf8Length } from "./utils";

const valid = {
  len: function(str, min, max) {
    let len = str.length;

    if (len < min || len > max) {
      return _("Range: %s - %s characters", [min, max]);
    }
  },
  // 字段名称
  fieldNameInput: function(str, min, max) {
    if (/[^\w\u4E00-\u9FA5_.\-()]/g.test(str)) {
      return _("支持中英文、数字和部分字符 _-.()");
    }
    let len = str.length;

    if (len < min || len > max) {
      return _("Range: %s - %s characters", [min, max]);
    }
  },

  nameInput: function(str, min, max) {
    if (/[^\w\u4E00-\u9FA5_.-]/g.test(str)) {
      return _("支持中英文、数字和部分字符 _-.");
    }
    let len = str.length;

    if (len < min || len > max) {
      return _("Range: %s - %s characters", [min, max]);
    }
  },

  inputNameInput: function(str, min, max) {
    if (/[^\w\u4E00-\u9FA5.-]/g.test(str) || !/^(?!.*_.*$)/g.test(str)) {
      return _("支持中英文、数字和部分字符 -.");
    }
    let len = str.length;

    if (len < min || len > max) {
      return _("Range: %s - %s characters", [min, max]);
    }
  },

  topic: function(str, min, max) {
    if (!/^[a-zA-Z0-9${}_/]+$/g.test(str)) {
      return _("支持英文、数字和部分字符 ${}_/");
    }
    let len = str.length;

    if (len < min || len > max) {
      return _("Range: %s - %s characters", [min, max]);
    }
  },

  topicinfo: function(str, min, max) {
    if (!/^[a-zA-Z0-9${}_/-]+$/g.test(str)) {
      return _("支持英文、数字和部分字符 ${}_/-");
    }
    let len = str.length;

    if (len < min || len > max) {
      return _("Range: %s - %s characters", [min, max]);
    }
  },

  identifier: function(str, min, max) {
    if (!/^[a-zA-Z0-9_]+$/g.test(str)) {
      return _("支持英文、数字和部分字符 _");
    }
    let len = str.length;

    if (len < min || len > max) {
      return _("Range: %s - %s characters", [min, max]);
    }
  },

  verification_code: function(str, min) {
    let len = str.length;

    if (len != min) {
      return _("请输入 %s 个字符", [min]);
    }
  },

  byteLen: function(str, min, max) {
    let totalLength = getUtf8Length(str);

    if (
      typeof min !== "undefined" &&
      typeof max !== "undefined" &&
      (totalLength < min || totalLength > max)
    ) {
      return _("Range: %s - %s bytes", [min, max]);
    }
  },
  num: function(str, min, max) {
    if (!/^([-0-9])?([0-9]+)$/.test(str)) {
      return _("Please enter digit");
    }
    if (typeof min === "number" && typeof max === "number") {
      if (parseInt(str, 10) < min || parseInt(str, 10) > max) {
        return _("Range: %s - %s", [min, max]);
      }
    }
  },
  float: function(str, min, max) {
    //支持小数点后一位
    if (!/^([-0-9])?([0-9]+)(\.[0-9]{0,1})?$/.test(str)) {
      return _("Please enter digit");
    }
    if (typeof min === "number" && typeof max === "number") {
      if (Number(str) < min || Number(str) > max) {
        return _("Range: %s - %s", [min, max]);
      }
    }
  },

  /**
   * [验证单个数字或数字范围，如端口范围设置（xx或xx-xxx）]
   */
  range: function(str, min, max) {
    let reg2 = /^(([1-9])?([0-9]+)){1}-(([1-9])?([0-9]+)){1}$/; //端口范围
    let result = "";
    if (!reg2.test(str)) {
      result = valid.num(str, min, max);
      if (result !== undefined) {
        return result;
      }
    } else {
      //验证端口范围 TODO
      let ptSt = str.split("-")[0],
        ptEd = str.split("-")[1];
      if (+ptSt >= +ptEd) {
        return _("Range: %s - %s", [min, max]);
      }

      if (typeof min === "number" && typeof max === "number") {
        if (Number(ptSt) < min || Number(ptEd) > max) {
          return _("Range: %s - %s", [min, max]);
        }
      }
    }
  },

  mac: {
    all: function(str) {
      let ret = this.specific(str);

      if (ret) {
        return ret;
      }

      if (
        !/^([0-9a-fA-F]{2}:){5}[0-9a-fA-F]{2}$/.test(str) &&
        !/^([0-9a-fA-F]{2}-){5}[0-9a-fA-F]{2}$/.test(str)
      ) {
        return _("Please enter a valid MAC address");
      }
    },

    specific: function(str) {
      let subMac1 = str.split(":")[0];

      if (subMac1.charAt(1) && parseInt(subMac1.charAt(1), 16) % 2 !== 0) {
        return _(
          "The second character of the MAC address must be an even number"
        );
      }
      if (str === "00:00:00:00:00:00") {
        return _("Cannot be 00:00:00:00:00:00");
      }
    },
  },

  ip: {
    all: function(str) {
      let ret = this.specific(str);

      if (ret) {
        return ret;
      }

      if (
        !/^([1-9]|[1-9]\d|1\d\d|2[0-1]\d|22[0-3])\.(([0-9]|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.){2}([0-9]|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])$/.test(
          str
        )
      ) {
        return _("Please enter a valid IP address");
      }
    },

    specific: function(str) {
      let ipArr = str.split("."),
        ipHead = ipArr[0];

      if (ipArr[0] === "127") {
        return _(
          "IP address starting with 127 is a loopback IP address. Specify another valid value between 1 and 223"
        );
      }
      if (Number(ipArr[0]) > 223) {
        return _(
          "IP address cannot start with %s. Specify a value between 1 and 223",
          [ipHead]
        );
      }
    },
  },
  ipAll: function(str) {
    let ret;
    if (str !== "0.0.0.0") {
      ret = valid.ip.all(str);
      if (ret) {
        return ret;
      }
    }
  },
  maskAll: {
    all: function(str, msg) {
      let rel = /^(254|252|248|240|224|192|128|0)\.0\.0\.0$|^(255\.(254|252|248|240|224|192|128|0)\.0\.0)$|^(255\.255\.(254|252|248|240|224|192|128|0)\.0)$|^(255\.255\.255\.(255|254|252|248|240|224|192|128|0))$/;
      if (!rel.test(str)) {
        return msg || _("Please enter a valid subnet mask");
      }
    },
  },
  dns: function() {},

  mask: {
    all: function(str) {
      let rel = /^(254|252|248|240|224|192|128)\.0\.0\.0$|^(255\.(254|252|248|240|224|192|128|0)\.0\.0)$|^(255\.255\.(254|252|248|240|224|192|128|0)\.0)$|^(255\.255\.255\.(255|254|252|248|240|224|192|128|0))$/;
      if (!rel.test(str)) {
        return _("Please enter a valid subnet mask");
      }
    },
  },

  email: function(str) {
    let rel = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
    if (!rel.test(str)) {
      return _("Please enter a valid email address");
    }
  },

  phone: function(str) {
    let rel = /^((13[0-9])|(15[^4,\D])|(14[57])|(17[0678])|(18[0,0-9]))\d{8}$/g;
    if (!rel.test(str)) {
      return _("请输入正确的号码");
    }
  },

  url: {
    all: function(str) {
      let reg = /((http|https):\/\/)*[\w\-_]+(\.[\w\-_]+)+([\w\-.,@?^=%&:/~+#]*[\w\-@?^=%&/~+#])?/;
      if (!reg.test(str)) {
        return _("Please enter a valid URL");
      }
    },
  },

  ascii: function(str, min, max) {
    if (!/^[ -~]+$/g.test(str)) {
      return _("Please enter ASCII characters");
    }
    if(/\s/g .test(str)){
      return ("禁止输入空格")
    }
    if (min || max) {
      return valid.len(str, min, max);
    }
  },
  userPwd: function(str, min, max) {
    if (!/^[ -~]+$/g.test(str)) {
      return _("Please enter ASCII characters");
    }
    if (/^ /.test(str) || / $/.test(str)) {
      return _("A password cannot start or end with a space");
    }

    if (min || max) {
      return valid.len(str, min, max);
    }
  },
  pppoe(str, min, max) {
    let rel = /[^\x00-\x80]|[~;'&"%\s]/;
    if (rel.test(str)) {
      return _(
        "Cannot contain space, Chinese character or special character ~ ; ' & \" %"
      );
    }
    if (min || max) {
      return valid.len(str, min, max);
    }
  },
  vpn(str) {
    if (!/^[0-9a-zA-Z_]+$/.test(str)) {
      return _(
        "Please enter digits, uppercase or lowercase letters, or underscores"
      );
    }
  },

  pwd: {
    all: function(str, minLen, maxLen) {
      let ret = this.specific(str);
      if (ret) {
        return ret;
      }

      if (minLen && maxLen) {
        ret = valid.len(str, minLen, maxLen);
        if (ret) {
          return ret;
        }
      }
    },
    specific: function(str) {
      if (!/^[0-9a-zA-Z_]+$/.test(str)) {
        return _(
          "Please enter digits, uppercase or lowercase letters, or underscores"
        );
      }
    },
  },

  domain: function(str) {
    if (!/^[\d.]+$/.test(str)) {
      if (
        /^[0-9a-z]([0-9a-z-]+\.){1,}([0-9a-z])+$/i.test(str) ||
        str == "localhost"
      ) {
        return;
      } else {
        return _("Please enter a valid domain name");
      }
    } else {
      return _("Please enter a valid domain name");
    }
  },

  ping: function(str) {
    let ip = valid.ip.all(str),
      domain = valid.domain(str);
    if (ip && domain) {
      return _("Please enter a valid domain name");
    }
  },

  ddns: function(str) {
    let ret;
    ret = valid.ascii(str, "", "");
    if (ret) {
      return ret;
    }
    ret = valid.remarkTxt(str, ";");
    if (ret) {
      return ret;
    }
  },

  remarkTxt: function(str, banStr) {
    let len = banStr.length,
      curChar,
      i;

    for (i = 0; i < len; i++) {
      curChar = banStr.charAt(i);
      if (str.indexOf(curChar) !== -1) {
        return _("%s is not allowed", [curChar]);
      }
    }
  },
  devName: function(str) {
    if (str.replace(/\s/g, "") == "") {
      return _("Device name cannot be spaces only");
    }
    if (str.length > 20) {
      return _("Device name can contain a maximum of %s characters", [20]);
    }
  },
};

export { valid };
